import { render, staticRenderFns } from "./ingreso.vue?vue&type=template&id=330ed14c&scoped=true"
import script from "./ingreso.vue?vue&type=script&lang=js"
export * from "./ingreso.vue?vue&type=script&lang=js"
import style0 from "./ingreso.vue?vue&type=style&index=0&id=330ed14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ed14c",
  null
  
)

export default component.exports